<template>
    <header
        class="d-flex justify-content-between align-items-center"
        :class="['header', {elevated}]"
        data-cy="header"
    >
        <div class="menu-toggle-button ml-4">
            <FontAwesomeIcon
                :icon="['fas','bars']"
                size="lg"
                data-cy="mobileMenuToggle"
                @click="$emit('toggle-mobile-menu')"
            />
        </div>

        <div class="header-branding">
            <!-- Content to be displayed in the branding section -->
            <slot name="branding">
                <!-- IMT Logo -->
                <IMTLogo
                    data-cy="headerBranding"
                    height="5rem"
                />
            </slot>
        </div>

        <div class="d-flex flex-grow-1 align-items-center h-100">
            <div class="header-content d-flex align-items-center">
                <!-- Content to be displayed between the branding and User Dropdown sections -->
                <slot />
            </div>
        </div>

        <div class="header-user-dropdown mr-4">
            <!-- Content to be displayed in the User Dropdown section -->
            <slot name="user-dropdown">
                <!-- `UserDropdown` -->
                <UserDropdown
                    :variant="variant"
                    @logout="logout"
                    @reset-password="resetPassword"
                >
                    {{ user.firstName }}
                    <br>
                    {{ user.lastName }}

                    <template #user-dropdown-header>
                        <!-- Pass through content to the `UserDropdown` `user-dropdown-header` slot -->
                        <slot name="user-dropdown-header" />
                    </template>

                    <template #user-dropdown-items>
                        <!-- Pass through content to the `UserDropdown` `user-dropdown-items` slot -->
                        <slot name="user-dropdown-items" />
                    </template>
                </UserDropdown>
            </slot>
        </div>
    </header>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core';
    import {faBars} from '@fortawesome/pro-solid-svg-icons';
    import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

    import IMTLogo from '../IMTLogo.vue';
    import UserDropdown from './UserDropdown.vue';

    library.add(faBars);

    /**
     * @group Layout
     * A component to display a Header.
     */
    export default {
        name: 'Header',
        components: {
            FontAwesomeIcon,
            UserDropdown,
            IMTLogo,
        },
        props: {
            /**
             * Display a shadow below the header
             */
            elevated: {
                type: Boolean,
                required: false,
                // `false`
                default: false,
            },
            /**
             * Pass user information to the User Dropdown component
             */
            user: {
                type: Object,
                required: false,
                // `{}`
                default: () => ({}),
            },
            /**
             * Sets the variant/type of header
             */
            variant: {
                // `default` / `policy-system`
                type: String,
                // `default`
                default: 'default',
                validator: (value) => {
                    return ['default', 'policy-system'].includes(value);
                },
            },
        },
        methods: {
            logout() {
                /**
                 * Emitted when the logout item is clicked. Functionality for logging
                 * out should be handled in the parent.
                 */
                this.$emit('logout');
            },
            resetPassword() {
                /**
                 * Emitted when the reset password item is clicked. Functionality for resetting
                 * password should be handled in the parent.
                 */
                this.$emit('reset-password');
            },
        },
    };
</script>
